import { render, staticRenderFns } from "./shop-special-group.vue?vue&type=template&id=702f6711&scoped=true&"
import script from "./shop-special-group.vue?vue&type=script&lang=js&"
export * from "./shop-special-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702f6711",
  null
  
)

export default component.exports